/**
* @summary - Component that Provides Stock Register State Handling
* @author Yuvasri S
* @since 2024-07-31
*/
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    stockRegister: {
        itemcodeId: '',
        itemcode: '',
        itemCodeDesc: '',
        itemType: '',
        service: '',
        status: '',
        workGroup: '',
        quantity: '',
        minUnit: '',
        maxUnit: '',
        minPrice: '',
        maxPrice: '',
        currentStockLevel: '',
    },
    stockUpdate: {
        itemcode: '',
        itemCodeDesc: '',
        updateQuantity: '',
        costPerPieces: '',
        remarks: '',
    },
    stockAdjustment: {
        itemcode: '',
        itemCodeDesc: '',
        adjustmentNo: '',
        adjustmentDate: '',
        quantityInSystem: '',
        physicalQuantity: '',
        variance: '',
        adjustmentQuantity: ''
    },
    srPrimaryId: null,
};

const stockSlice = createSlice({
    name: 'stock',
    initialState,
    reducers: {
        updateCreateStockRegister: (state, action) => {
            state.stockRegister = { ...state.stockRegister, ...action.payload };
        },
        updateStockUpdate: (state, action) => {
            state.stockUpdate = { ...state.stockUpdate, ...action.payload };
        },
        updateStockAdjustment: (state, action) => {
            state.stockAdjustment = { ...state.stockAdjustment, ...action.payload };
        },
        resetCreateStockRegister: (state) => {
            state.stockRegister = initialState.stockRegister;
        },
        resetEditStockUpdate: (state) => {
            state.stockUpdate = initialState.stockUpdate;
        },
        resetEditStockAdjustment: (state) => {
            state.stockAdjustment = initialState.stockAdjustment;
        },
        setSrPrimaryId: (state, action) => {
            state.srPrimaryId = action.payload;
        },
    },
});

export const { updateCreateStockRegister, updateStockUpdate, updateStockAdjustment, resetCreateStockRegister, resetEditStockUpdate, resetEditStockAdjustment, setSrPrimaryId } = stockSlice.actions;

export default stockSlice.reducer;
